import { Button, Checkbox, Col, Form, Input, message, Row } from "antd";
import React, { useEffect, useState } from "react";
import PhoneFormat from "../../../components/models/format/phonenumber/format_number";
import { parseCustomerText } from "../../../utils/autoFillCustomer";
import { API } from "../../../setup/setupAxios";

const InputCustomer = (props) => {
    const { modal, editData, viewMode, hitApi } = props;
    const [form] = Form.useForm();
    const [useAutoFill, setUseAutoFill] = useState(false)
    const [isSubmitting, setIsSubmitting] = useState(false);
    const isEditMode = !!editData;
    useEffect(() => {
        if (editData) {
            form.setFieldsValue({
                noMember: editData.noMember || "",
                nama: editData.nama || "",
                alamat: editData.alamat|| "",
                noTelepon: editData.noTelepon || "",
                email: editData.email || "",
            });
        } else {
            form.resetFields();
        }
    }, [editData, form]);
    const handleCreate = async (values) => {
        const payload = { ...values };
        setIsSubmitting(true);
        try {
            await API.post("/api/customer", payload);
            message.success("Data berhasil disimpan");
            form.resetFields();
            hitApi();
            modal(false);
        } catch (error) {
            console.error("Gagal menyimpan data:", error);
            message.error("Data tidak dapat disimpan");
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleUpdate = async (values) => {
        const payload = { id: editData?.id, ...values };
        setIsSubmitting(true);
        try {
            await API.put(`/api/customer/${editData?.id}`, payload);
            message.success("Data berhasil diperbarui");
            hitApi();
            modal(false);
        } catch (error) {
            console.error("Gagal memperbarui data:", error);
            message.error("Data tidak dapat diperbarui");
        } finally {
            setIsSubmitting(false);
        }
    };

    const onFinish = (values) => {
        if (isEditMode) handleUpdate(values);
        else handleCreate(values);
    };

    return (
        <>
        <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
        >
            {isEditMode || viewMode ? (
                null
            ):(
                <>
                    <Checkbox
                        checked={useAutoFill}
                        onChange={(e) => {
                            setUseAutoFill(e.target.checked);
                        }}
                    >
                        Ambil data dari whatsApp
                    </Checkbox>
                    <hr />
                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item label="Tempel Data Customer">
                                <Input.TextArea
                                    rows={4}
                                    placeholder={`Example:
                    nama customer: A
                    alamat customer: B
                    nomor telepon customer: 0821123456789
                    email customer: customer1@gmail.com`}
                                    onBlur={(e) => {
                                        const parsedData = parseCustomerText(e.target.value);
                                        form.setFieldsValue(parsedData);
                                    }}
                                    disabled={viewMode || !useAutoFill}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </>
            )}
            <Row gutter={16}>
                <Col span={12}>
                    <Form.Item
                        label="No Member"
                        name="noMember"
                    >
                        <Input placeholder="Contoh: MBR-001 (Opsional)" disabled={viewMode} />
                    </Form.Item>
                </Col>

                <Col span={12}>
                    <Form.Item
                        label="Nama"
                        name="nama"
                        rules={[{ required: true, message: "Masukkan Nama Customer" }]}
                    >
                        <Input disabled={viewMode} />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={16}>
                <Col span={24}>
                    <Form.Item
                        label="Alamat"
                        name="alamat"
                        rules={[{ required: true, message: "Masukkan Alamat Customer" }]}
                    >
                        <Input.TextArea rows={2} disabled={viewMode} />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={16}>
                <Col span={12}>
                    <Form.Item
                        label="Nomor Telepon"
                        name="noTelepon"
                        rules={[{ required: true, message: "Masukkan Nomor Telepon" }]}
                    >
                        <PhoneFormat disabled={viewMode} />
                    </Form.Item>
                </Col>

                <Col span={12}>
                    <Form.Item
                        label="Email"
                        name="email"
                        rules={[
                            { type: "email", message: "Format email tidak valid" },
                            { required: false }
                        ]}
                    >
                        <Input disabled={viewMode} />
                    </Form.Item>
                </Col>
            </Row>
            {!viewMode && (
                <Row>
                    <Col span={24}>
                        <Button style={{ marginRight: 8 }} onClick={() => modal(false)}>
                            Cancel
                        </Button>

                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={isSubmitting}
                        >
                            {isEditMode ? "Perbarui" : "Simpan"}
                        </Button>
                    </Col>
                </Row>
            )}
        </Form>
        </>
    );
};

export default InputCustomer;